import restful from '../vuex'
import axios from 'axios'
import { Message, Spin } from 'view-design'

const state = {
  ...restful.states('mall_order')
}

const getters = {
  ...restful.getters('mall_order'),
  aggregate_test: (state) =>
    `搜索结果：总计 ${state.meta.first} 笔订单，总销售额为 ${state.meta.second} 元，会员销售额为 ${state.meta.third}`
}

const actions = {
  ...restful.actions('mall_orders'),
  async deliver_order ({ commit }, id) {
    Spin.show()
    const res = await axios.post(`mall_orders/${id}/deliver`)
    commit('setRecord', res.data)
    Spin.hide()
    Message.success('已设置发货')
  }
}

const mutations = {
  ...restful.mutations('mall_order')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
